import { Skeleton } from '@portals-platform/ui';

export function LoadingPage() {
  return (
    <div className="flex h-screen bg-[var(--color-background)]">
      <div className="flex w-64 flex-col gap-3 border-r border-[var(--color-border)] p-4">
        <Skeleton className="h-8 w-32" />
        <div className="flex flex-col gap-2 pt-4">
          {Array.from({ length: 6 }).map((_, i) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton list
            <Skeleton key={i} className="h-8 w-full" />
          ))}
        </div>
      </div>
      <div className="flex flex-1 flex-col gap-4 p-6">
        <Skeleton className="h-8 w-48" />
        <div className="grid grid-cols-4 gap-4">
          {Array.from({ length: 4 }).map((_, i) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton list
            <Skeleton key={i} className="h-28 w-full rounded-lg" />
          ))}
        </div>
        <Skeleton className="h-64 w-full rounded-lg" />
      </div>
    </div>
  );
}
